import React from 'react'

export default function Intro(props) {
  const staticVersion = props.staticVersion;
  return (
    <section className="flush--bottom">
      <a className="anchor" id="intro"></a>
      <div className="grid grid--bleed">
        <div className="grid__col-sm-12 main">
          <div className="well text--center banner">
            <h1 className="fitText flush--bottom">Common UI</h1>
          </div>
        </div>
      </div>
      <br/><br/><br/>
      <div className="grid content--middle">
        <div className="grid__col-sm-12 main">
          <div className="grid">
            <div className="grid__col-xs-6 grid__col-sm-3">
              <div className="media media--stacked text--center">
                <i className="fa fa-rocket" aria-hidden="true" style={{
                  "fontSize": "8em"
                }}></i>
                <div className="media__body">
                  <h3 className="push--top">Solid Foundation</h3>
                  Built on a foundation of <a href="http://necolas.github.io/normalize.css/">Normalize.css</a>
                </div>
              </div>
            </div>
            <div className="grid__col-xs-6 grid__col-sm-3">
              <div className="media media--stacked text--center">
                <div style={{
                  "height": "8em",
                  "display": "flex",
                  "flexDirection": "row",
                  "alignItems": "center",
                  "justifyContent": "center"
                }}>
                  <i className="fa fa-mobile fa-3x" aria-hidden="true"></i>
                  <i className="fa fa-tablet fa-3x" aria-hidden="true"></i>
                  <i className="fa fa-desktop fa-3x" aria-hidden="true"></i>
                </div>
                <div className="media__body">
                  <h3 className="push--top">Made with mobile in mind</h3>
                  Responsive out of the box, so elements look great on all screens.
                </div>
              </div>
            </div>
            <div className="grid__col-xs-6 grid__col-sm-3">
              <div className="media media--stacked text--center">
                <i className="fa fa-gears" aria-hidden="true" style={{
                  "fontSize": "8em"
                }}></i>
                <div className="media__body">
                  <h3 className="push--top">Semantic</h3>
                  BEM syntax keeps the CSS clear and informative.
                </div>
              </div>
            </div>
            <div className="grid__col-xs-6 grid__col-sm-3">
              <div className="media media--stacked text--center">
                <i className="fa fa-code" aria-hidden="true" style={{
                  "fontSize": "8em"
                }}></i>
                <div className="media__body">
                  <h3 className="push--top">Tiny footprint</h3>
                  The core set of modules clocks in at 7.9KB minified and gzipped.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid content--middle">
        <div className="grid__col-sm-12 main">
          <section>
            <hr/>
            <br/><br/><br/>
            <h2 className="text--center">A HTML, CSS, and JS framework for developing responsive, mobile first projects for CME Group.</h2>
            { props.staticVersion === false ? ( <h3 className="text--center">Need a feature?   Found a bug?   Want to contribute?</h3> ) : ( '' ) }
            <br/><br/>
            <a href={props.staticVersion === true ? '#getting-started' : 'getting-started'} className="center btn btn--large btn--positive"><i className="fa fa-cog fa-lg"></i> Get Started!</a>&nbsp;{ props.staticVersion === false ? ( <a href="https://fisheye.chicago.cme.com:8663/changelog/common_ui" className="center btn btn--large"><i className="fa fa-code-fork fa-lg"></i> Common UI on Fisheye</a>) : ( '' ) }
          </section>
        </div>
      </div>
      <div className="grid content--middle">
        <div className="grid__col-sm-12 main">
          <section className="flush">
            <hr/>
            <br/><br/><br/>
            <h2 className="center text--center"><i className="fa fa-bolt fa-4x"></i></h2>
            <h2 className="text--center">Accelerate your development</h2>
          </section>
        </div>
        <div className="grid__col-sm-6">
          <ul className="list-dots h2">
            <li className="soft-half">20+ UI Components</li>
            <li className="soft-half">CME Group Branded</li>
            <li className="soft-half">Build cross-platform web applications delivering experience tailored to the user's screen size.</li>
            <li className="soft-half">Flexbox grid system for new layout possibilities</li>
          </ul>
        </div>
        <div className="grid__col-sm-6">
          <ul className="list-dots h2">
            <li className="soft-half">Easy to learn and use</li>
            <li className="soft-half">Leverages latest HTML5/JS features for modern browsers</li>
            <li className="soft-half">Supported upgrade path</li>
            <li className="soft-half">Sample layouts and code snippets to help you get started</li>
          </ul>
        </div>
      </div>
      <div className="grid content--middle">
        <div className="grid__col-sm-12 main">
          { props.staticVersion === false ? (
            <section>
              <br/><br/><br/>
              <h2 className="text--center">Got questions? Join the discussion</h2>
              <br/><br/>
              <a href="https://fadvhc0001d.chicago.cme.com/chat/room/414" className="center btn btn--large btn--positive"><i className="fa fa-comments fa-lg"></i> Hipchat!</a>&nbsp;<a href="getting-started#support" className="center btn btn--large"><i className="fa fa-question fa-lg"></i> Get some help</a>
            </section>
          ) : ( '' ) }
        </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/Intro.js